
(function() {
	var animationQueues = {
		main: {
			selector: '.anim-main',
			delay: 600
		},
		img: {
			selector: '.anim-img',
			delay: 400,
			// waitfor: ['main']
		},
		swiper: {
			selector: '.swiper-slide',
			delay: 400,
			waitfor: ['main']
		},
		default: {
			selector: '.anim-block-default',
			delay: 400,
			// waitfor: ['main']
		},
		text: {
			selector: '.anim-text',
			delay: 0,
			// waitfor: ['main']
		}
	};

	for (var name in animationQueues) {
		animationQueues[name] = $.extend({
			items: [],
			interval: false
		}, animationQueues[name]);
	}

	$(function() {
		for (var name in animationQueues) {
			$(animationQueues[name].selector).addClass('anim-init');
		}
	});

	$(window).on('DOMContentLoaded load resize scroll anim-init', function() {
		$(animationQueues['main'].selector + ':not(.anim-added)').each(function() {
			var $element = $(this);

			$('body').addClass('navbar-force-visible');
			addAnimationsQueueElement('main', $element);
			setTimeout(function() {
				$('body').removeClass('navbar-force-visible');
				$element.addClass('anim-started'); // just to make sure the overlay will surely disappear...
			}, 2000);
		});

		$.each(getElementsInViewport(animationQueues['img'].selector + ':not(.anim-added)'), function(key, $element) {
			if ($element.attr('src').indexOf('spacer.gif') >= 0) {
				return;
			}

			$element.addClass('anim-added').wrap('<span class="anim-img-bg" />').parent().each(function(next) {
				addAnimationsQueueElement('img', $(this));
			});
		});

		$.each(getElementsInViewport(animationQueues['swiper'].selector + ':not(.anim-added)'), function(key, $element) {
			addAnimationsQueueElement('swiper', $element);
		});

		$.each(getElementsInViewport(animationQueues['default'].selector + ':not(.anim-added)'), function(key, $element) {
			addAnimationsQueueElement('default', $element);
		});

		$.each(getElementsInViewport(animationQueues['text'].selector + ':not(.anim-added)'), function(key, $element) {
			addAnimationsQueueElement('text', $element);
		});
	});

	$(window).on('beforeunload', function() {
		$('.navbar-toggle.active a').trigger('click');
		$('body').addClass('navbar-force-visible');

		$(animationQueues['main'].selector).each(function() {
			$(this).addClass('anim-out');
		});
	});

	function shiftMostLeftQueueElement(queue) {
		var elementKey = -1;
		var mostLeft   = 0;

		for (var i in animationQueues[queue].items) {
			var $element = animationQueues[queue].items[i];
			var left     = $element.offset().left;

			if (mostLeft === 0 || left < mostLeft) {
				mostLeft   = left;
				elementKey = i;
			}
		}

		if (elementKey >= 0) {
			var $returnElement = animationQueues[queue].items[elementKey];
			animationQueues[queue].items.splice(elementKey, 1);
			return $returnElement;
		}

		return false;
	}

	function addAnimationsQueueElement(queue, $element) {
		$element.addClass('anim-added');
		animationQueues[queue].items.push($element);
		checkAnimationsQueue(queue);
		// console.log(queue, $element);
	}

	function checkAnimationsQueue(queue) {
		var queueLength = animationQueues[queue].items.length;
		var waitfor     = animationQueues[queue].waitfor;

		if (waitfor !== undefined) {
			for (var i in waitfor) {
				if (animationQueues[waitfor[i]].items.length > 0) {
					return;
				}
			}
		}

		if (animationQueues[queue].interval !== false || queueLength === 0) {
			return;
		}

		animationQueues[queue].interval = setInterval(function() {
			var $element = shiftMostLeftQueueElement(queue);

			if (!$element || queueLength === 0) {
				clearInterval(animationQueues[queue].interval);
				animationQueues[queue].interval = false;

				for (var i in animationQueues) {
					if (animationQueues[i].waitfor !== undefined && animationQueues[i].waitfor.indexOf(queue) >= 0) {
						checkAnimationsQueue(i);
					}
				}
				return;
			}

			$element.addClass('anim-started');
		}, animationQueues[queue].delay);
	}
})(window, undefined);
